angular.module('mercury.modules.qa.menumate.billpayments')
.controller('QaMenumateBillPaymentsReportCtrl', ["$http", "reporttime", "$scope", "title", "settings", function($http, reporttime, $scope, title, settings) {
  title.set('Bill Payments Report');

  $scope.loading = $http.get(settings.apiHost + '/r/PosQaMenumateBillPayments', {
    params: {
      startTime: reporttime.start(),
      endTime: reporttime.end()
    }
  });

  $scope.loading.then(function(response) {
    title.setSubheader(response.data.notes);
    $scope.tableData = response.data.lines;

    $scope.price = 0;
    $scope.subTotal = 0;
    var lastInvoiceNo = 0;

    angular.forEach(response.data.lines, function(line) {
      if (line.invoiceNumber == lastInvoiceNo) {
        line.invoiceNo = '';
        line.tableNumber = '';
        line.timeStamp = '';
        line.terminalName = '';
        line.staffName = '';
        line.price = '';
        $scope.subTotal += line.subTotal;
      } else {
        lastInvoiceNo = line.invoiceNumber;
        $scope.price += line.price;
        $scope.subTotal += line.subTotal;
      }
    });
  });
}]);
